import React, { FC, useState, useEffect } from 'react';
import { LawFirmPopoverInfos } from '../lawFirm.types';
import { fetchLawFirmInfos } from '../lawFirm.api';
import { LawFirmCard } from './LawFirmCard';
import { PopoverWrapper } from '../../components/popovers/wrapper/PopoverWrapper';
import { PopoverLoading } from '../../components/popovers/loading/PopoverLoading';
import { delayPromise } from '../../utils/promise';
import { doctrineAnalytics } from '../../utils/analyticsUtils';

type Props = {
  lawOfficeIdGroup: string;
  source: string;
};

export const LawFirmPopover: FC<Props> = ({ lawOfficeIdGroup, source }) => {
  const [lawFirmInfos, setLawFirmInfos] = useState<LawFirmPopoverInfos | null>(
    null,
  );
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    async function fetch() {
      setLoading(true);

      const { data } = await delayPromise(
        fetchLawFirmInfos(lawOfficeIdGroup),
        300,
      );
      doctrineAnalytics('DisplayLawFirmPopover');
      setLawFirmInfos(data);
      setLoading(false);
    }

    fetch();
  }, [lawOfficeIdGroup]);

  if (isLoading)
    return (
      <PopoverWrapper>
        <PopoverLoading />
      </PopoverWrapper>
    );

  if (!lawFirmInfos) return null;

  return (
    <PopoverWrapper>
      <LawFirmCard lawFirm={lawFirmInfos} source={source} />
    </PopoverWrapper>
  );
};
